import { LicenseManagementSchoolsServices } from './schools'
import { LicenseManagementUserGroupsServices } from './userGroups'

export const LicenseServices = {
  schools: LicenseManagementSchoolsServices,
  userGroups: LicenseManagementUserGroupsServices
}
export * from './LicenseManagement.types'
